import { render, staticRenderFns } from "./Aportacion_Comp.vue?vue&type=template&id=669639f6&scoped=true&"
import script from "./Aportacion_Comp.vue?vue&type=script&lang=js&"
export * from "./Aportacion_Comp.vue?vue&type=script&lang=js&"
import style0 from "./Aportacion_Comp.vue?vue&type=style&index=0&id=669639f6&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "669639f6",
  null
  
)

export default component.exports